import Header from "../Component/Header";

import { useNavigate } from "react-router-dom";
import {
  Layout,
  theme,
  Input,
  Popover,
  Button,
  DatePicker,
  Form,
  Table,
  Space,
} from "antd";
import { ControlOutlined, DeleteOutlined } from "@ant-design/icons";
import React, { useState, useEffect, useContext } from "react";
import dayjs from "dayjs";
import { GlobalContext } from "../Component/GlobalContextProvider";

import { gql, useMutation, useLazyQuery } from "@apollo/client";

var isBetween = require("dayjs/plugin/isBetween");
dayjs.extend(isBetween);
const { Search } = Input;
const { RangePicker } = DatePicker;

const GET_PROJECT_LIST = gql`
  query Query {
    get_all_project_with_client_name {
      id
      name
      client_name
    }
  }
`;

const GET_PROJECT_LIST_BY_TECHNICIAN_ID = gql`
  query Query($technician_id: uuid!) {
    get_project_list_by_technician_id(
      args: { input_technician_id: $technician_id }
    ) {
      id
      name
      client_name
    }
  }
`;

const DELETE_PROJECT = gql`
  mutation Mutation($id: uuid!) {
    delete_project_by_pk(id: $id) {
      id
    }
  }
`;

function ProjectList() {
  const [height, setHeight] = useState(window.innerHeight);
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [fetchData, setFetchData] = useState([]);

  const {
    RequestListData,
    fetchRequestList,
    RequestListLoading,
    fetchAllRequestList,
    AllRequestListLoading,
    AllRequestListData,
    userId,
    setSelectProjectId,
    isManager,
    setMenuNavigationPage,
  } = useContext(GlobalContext);

  const [
    fetchProjectList,
    { data: projectList, refetch, loading: projectListLoading },
  ] = useLazyQuery(
    isManager ? GET_PROJECT_LIST : GET_PROJECT_LIST_BY_TECHNICIAN_ID
  );

  const [deleteProject] = useMutation(DELETE_PROJECT);

  useEffect(() => {
    setMenuNavigationPage("Project");
  }, [setMenuNavigationPage]);

  useEffect(() => {
    if (userId) {
      if (isManager) {
        fetchAllRequestList();
        fetchProjectList();
      } else {
        fetchProjectList({ variables: { technician_id: userId } });
        fetchRequestList({ variables: { technician_id: userId } });
      }
    }
  }, [
    fetchProjectList,
    userId,
    fetchRequestList,
    fetchAllRequestList,
    isManager,
  ]);

  useEffect(() => {
    if (projectList) {
      console.log(projectList);
    }
  }, [projectList]);

  useEffect(() => {
    const data = isManager ? AllRequestListData : RequestListData;
    if (!data || !projectList) return;

    const list = isManager
      ? projectList.get_all_project_with_client_name
      : projectList.get_project_list_by_technician_id;
    const groupedRequests = list.map((project) => ({
      project_id: project.id,
      project_name: project.name,
      latest_due_date: null,
      latest_update_date: null,
      total_unread_messages: 0,
      requestAmount: 0,
      clientName: project.client_name,
    }));

    const requestList = isManager
      ? data.get_all_requests_with_technician_names
      : data.get_request_list_by_technician_id;
    // update the groupedRequests with the latest due date, update date, and total unread <messages></messages>

    requestList.forEach((current) => {
      const existingProject = groupedRequests.find(
        (item) => item.project_id === current.project_id
      );

      if (existingProject) {
        if (
          current.due_date &&
          (!existingProject.latest_due_date ||
            new Date(current.due_date) >
              new Date(existingProject.latest_due_date))
        ) {
          existingProject.latest_due_date = current.due_date;
        }
        if (
          current.update_date &&
          (!existingProject.latest_update_date ||
            new Date(current.update_date) >
              new Date(existingProject.latest_update_date))
        ) {
          existingProject.latest_update_date = current.update_date;
        }
        existingProject.total_unread_messages +=
          current.technician_unread_message_count;
        existingProject.requestAmount += 1;
      }
    });

    const formattedRequests = groupedRequests.map((element) => ({
      key: element.project_id,
      title: element.project_name,
      deadline: element.latest_due_date
        ? new Date(element.latest_due_date).toLocaleDateString("en-NZ")
        : "TBD",
      update: element.latest_update_date
        ? new Date(element.latest_update_date).toLocaleDateString("en-NZ")
        : "TBD",
      unreadMessageCount: element.total_unread_messages,
      requestAmount: element.requestAmount, // request amount
      clientName: element.clientName,
    }));
    console.log(formattedRequests);
    setFetchData(formattedRequests);
    setProjects(formattedRequests);
  }, [RequestListData, AllRequestListData, projectList, isManager]);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  //This function is used to handle search request, info?.source will return 'input'
  const onSearch = (value, _e, info) => {
    setProjects(
      fetchData.filter((project) => {
        return project.title.toLowerCase().includes(value.toLowerCase());
      })
    );
  };
  const onFilterFinish = (values) => {
    let searchResult = fetchData;
    if (values.status && values.status.length > 0) {
      searchResult = searchResult.filter((project) =>
        values.status.some((status) => project.status.includes(status))
      );
    }
    if (values.deadline) {
      searchResult = searchResult.filter((project) => {
        if (project.deadline) {
          return dayjs(project.deadline, "DD MM YYYY").isBetween(
            values.deadline[0],
            values.deadline[1]
          );
        } else {
          return false;
        }
      });
    }
    if (values.Updated) {
      searchResult = searchResult.filter((project) => {
        if (project.update) {
          return dayjs(project.update, "DD MM YYYY").isBetween(
            values.Updated[0],
            values.Updated[1]
          );
        } else {
          return false;
        }
      });
    }
    setProjects(searchResult);
  };
  const onFilterFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const filter = (
    <Form
      name="basic"
      labelCol={{
        span: 6,
      }}
      wrapperCol={{
        span: 16,
      }}
      style={{
        maxWidth: 350,
      }}
      initialValues={{
        remember: true,
      }}
      onFinish={onFilterFinish}
      onFinishFailed={onFilterFinishFailed}
      autoComplete="off"
    >
      <Form.Item label="Deadline" name="deadline">
        <RangePicker />
      </Form.Item>
      <Form.Item label="Updated" name="Updated">
        <RangePicker />
      </Form.Item>
      <Form.Item
        wrapperCol={{
          offset: 8,
          span: 16,
        }}
      >
        <Button htmlType="submit">Apply Filiter</Button>
      </Form.Item>
    </Form>
  );
  const columns = [
    {
      title: "Project Title",
      dataIndex: "title",
      key: "title",
      render: (_, { title, unreadMessageCount, requestAmount, key }) => {
        return (
          <Space
            direction="horizontal"
            style={{ height: "100%", alignItems: "center" }}
          >
            {isManager && (
              <Button
                type="text"
                icon={<DeleteOutlined style={{ color: "#e25050" }} />}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteProject({ variables: { id: key } }).then(() => {
                    refetch();
                  });
                }}
              />
            )}
            <div
              style={{
                width: "100%",
                float: "left",
                height: "100%",
                alignItems: "center",
                display: "flex",
              }}
            >
              {title}
            </div>

            {unreadMessageCount !== 0 && (
              <div
                style={{
                  marginLeft: 35,
                  fontWeight: "bold",
                  display: "flex",
                  borderRadius: "50%",
                  backgroundColor: "red",
                  color: "white",
                  fontSize: unreadMessageCount > 99 ? 9 : 11,
                  width: 20,
                  height: 20,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {unreadMessageCount > 99 ? "99+" : unreadMessageCount}
              </div>
            )}
          </Space>
        );
      },
    },
    {
      title: "Due date",
      dataIndex: "deadline",
      key: "deadline",
      render: (text) => (text === null ? <p>TBD</p> : <p>{text}</p>),
      sorter: (a, b) => {
        const dateA = dayjs(a.deadline, "DD MM YYYY");
        const dateB = dayjs(b.deadline, "DD MM YYYY");

        if (!dateA.isValid()) {
          return -1;
        }
        if (!dateB.isValid()) {
          return 1;
        }

        return dateA.unix() - dateB.unix();
      },
    },

    {
      title: "Updated date",
      dataIndex: "update",
      key: "update",
      render: (text) => (text === null ? <p>TBD</p> : <p>{text}</p>),
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        const dateA = dayjs(a.update, "DD MM YYYY");
        const dateB = dayjs(b.update, "DD MM YYYY");

        if (!dateA.isValid()) {
          return 1;
        }
        if (!dateB.isValid()) {
          return -1;
        }

        return dateA.unix() - dateB.unix();
      },
    },
    {
      title: "Request amount",
      dataIndex: "requestAmount",
      key: "requestAmount",
      sorter: (a, b) => a.requestAmount - b.requestAmount,
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
      render: (text) => <p>{text}</p>,
    },
  ];
  return (
    <Header select="Project">
      <Layout.Content
        style={{
          padding: 24,
          marginLeft: 2,
          minHeight: 280,
          background: colorBgContainer,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Popover
            content={filter}
            placement="bottomLeft"
            trigger="click"
            arrow={false}
          >
            <ControlOutlined style={{ fontSize: 26, marginRight: 30 }} />
          </Popover>

          <Search
            placeholder="search project by title"
            onSearch={onSearch}
            style={{ width: 400 }}
          />
        </div>

        <Table
          style={{ paddingTop: 24 }}
          columns={columns}
          loading={
            isManager
              ? AllRequestListLoading
              : RequestListLoading || projectListLoading
          }
          dataSource={projects}
          pagination={false}
          virtual
          scroll={{ y: height - 210 }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                setSelectProjectId(record.key);
                navigate("/request_list");
              },
            };
          }}
        />
      </Layout.Content>
    </Header>
  );
}

export default ProjectList;
